import {
  AlertDialog as Dialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle
} from '@cutilei/ui'

/*
  Escolha entre várias opções, sobre o AlertDialog do @cutilei/ui, com as props de antes do Design
  System. Os botões ficam empilhados, com a largura toda: a primeira opção é a principal (ou a
  vermelha, com `dangerous`), e as outras são secundárias.

  Como todo AlertDialog, não tem X nem fecha com clique fora. Para desistir:
  - uma opção cujo `onClick` é o próprio `onClose` (o "Não" de várias telas) vira o botão de
    cancelar, que recebe o foco ao abrir e fecha uma vez só;
  - sem uma opção assim, entra um "Voltar" (`cancelText`) no fim. Passe `cancelText={null}` para
    não ter.

  Com `closeOnConfirm={false}`, escolher uma opção não fecha: a tela fecha pelo `visible`.

  O `buttonStyle` não é mais usado: as telas só passavam larguras fixas para as opções caberem
  lado a lado, e empilhadas elas já ocupam a largura toda.
*/
export default function OptionDialog({
  visible,
  title = 'Selecionar opção',
  message,
  onClose: handleClose = () => {},
  closeOnConfirm = true,
  cancelText = 'Voltar',
  containerStyle = {},
  options = [
    {label: 'Opção 1', onClick: () => null, dangerous: false},
    {label: 'Opção 2', onClick: () => null, dangerous: false}
  ]
}) {
  const hasCancelOption = options.some(option => option.onClick === handleClose)

  const handleOptionSelected = (event, option) => {
    // Sem isso o Radix fecharia sozinho: quem fecha é a tela, e só com `closeOnConfirm`.
    event.preventDefault()
    option.onClick()
    if (closeOnConfirm) handleClose()
  }

  return (
    <Dialog open={Boolean(visible)} onOpenChange={open => { if (!open) handleClose() }}>
      <AlertDialogContent style={containerStyle || undefined}>
        <AlertDialogHeader>
          <AlertDialogTitle>{title}</AlertDialogTitle>
          <AlertDialogDescription asChild>
            <div>{message}</div>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter fullWidth>
          {options.map((option, index) => (
            option.onClick === handleClose ? (
              <AlertDialogCancel key={index}>
                {option.label}
              </AlertDialogCancel>
            ) : (
              <AlertDialogAction
                key={index}
                variant={option.dangerous || index === 0 ? 'primary' : 'secondary'}
                destructive={Boolean(option.dangerous)}
                onClick={event => handleOptionSelected(event, option)}
              >
                {option.label}
              </AlertDialogAction>
            )
          ))}
          {!hasCancelOption && cancelText && (
            <AlertDialogCancel variant='ghost'>
              {cancelText}
            </AlertDialogCancel>
          )}
        </AlertDialogFooter>
      </AlertDialogContent>
    </Dialog>
  )
}
